import React from "react";
import Login from "../components/UI/login-form/Login"

function LoginPage(...props){
    return (
        <div className="App">
            <Login/>
        </div>
    )
}

export default LoginPage;